import React from 'react'

const Footer = () => {
    return (
        <footer>
             <p>copyright &copy; 2021</p>
            <a href='/about'>About</a>     
        </footer>
    )
}

export default Footer
